import CustomTransferListWithoutActionButtons from 'Components/CustomTransferListWithoutActionButtons'
import {
  useGetAllowedApiClientsQuery,
  useGetSpmAllowedApiClientsQuery
} from 'Services/common/Features/AllowedApiClient/allowedApiClientApi'
import { Service } from 'Util/constants'
import { Box, ListItemText, Typography } from '@mui/material'
import { t } from 'ttag'

interface AllowedApiClientsProps {
  service: Service
  selectedReadClients: string[]
  selectedWriteClients: string[]
  setSelectedReadClients: (selectedReadClients: string[]) => void
  setSelectedWriteClients: (selectedWriteClients: string[]) => void
}

export default function AllowedApiClients({
  service,
  selectedReadClients,
  selectedWriteClients,
  setSelectedReadClients,
  setSelectedWriteClients
}: Readonly<AllowedApiClientsProps>) {
  const productManagementAllowedApiClientsQuery = useGetAllowedApiClientsQuery(
    { exclude_manager_api_client: true },
    { skip: service !== Service.PRODUCT_MANAGEMENT }
  )
  const spmAllowedApiClientsQuery = useGetSpmAllowedApiClientsQuery(
    { exclude_manager_api_client: true },
    { skip: service !== Service.SERVICE_PROVIDER_MANAGEMENT }
  )

  const {
    data: { api_clients: allAllowedApiClients = [] } = { api_clients: [] },
    isLoading: isAllAllowedApiClientsLoading
  } =
    service === Service.PRODUCT_MANAGEMENT
      ? productManagementAllowedApiClientsQuery
      : spmAllowedApiClientsQuery

  const renderItemContent = (clientId: string) => {
    const allowedClient = allAllowedApiClients.find(client => client.client_id === clientId)
    const labelId = `transfer-list-item-${clientId}-label`
    return (
      <ListItemText
        id={labelId}
        primary={allowedClient?.client_name}
        secondary={allowedClient?.client_id}
      />
    )
  }

  const allowedApiClientOptions = allAllowedApiClients.map(client => client.client_id)

  const handleReadClientsChange = (selectedItems: string[]) => {
    setSelectedReadClients(selectedItems)
  }

  const handleWriteClientsChange = (selectedItems: string[]) => {
    setSelectedWriteClients(selectedItems)
  }

  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        rowGap: 2
      }}
    >
      <Box>
        <Typography variant="subtitle2" fontWeight="bold">{t`Client read permissions`}</Typography>
        <CustomTransferListWithoutActionButtons
          leftItemsHeaderText={t`All API clients`}
          rightItemsHeaderText={t`Selected API clients`}
          leftItems={allowedApiClientOptions}
          rightItems={selectedReadClients}
          renderItemContent={renderItemContent}
          optionsLoading={isAllAllowedApiClientsLoading}
          handleItemsChange={selectedItems => handleReadClientsChange(selectedItems)}
          allowTransferBack={true}
          customStyles={{ maxHeight: '200px' }}
        />
      </Box>
      <Box>
        <Typography variant="subtitle2" fontWeight="bold">{t`Client write permissions`}</Typography>
        <CustomTransferListWithoutActionButtons
          leftItemsHeaderText={t`All API clients`}
          rightItemsHeaderText={t`Selected API clients`}
          leftItems={allowedApiClientOptions}
          rightItems={selectedWriteClients}
          renderItemContent={renderItemContent}
          optionsLoading={isAllAllowedApiClientsLoading}
          handleItemsChange={selectedItems => handleWriteClientsChange(selectedItems)}
          allowTransferBack={true}
          customStyles={{ maxHeight: '200px' }}
        />
      </Box>
    </Box>
  )
}
